import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import OAuthPage from './pages/auth/oauthPage';
import LoginPage from './pages/auth/LoginPage';
import PrivateRoute from "./components/auth/PrivateRoute";
import DashboardPage from './pages/DashboardPage';
import LLMManagementPage from './pages/LLMManagementPage';
import ReportingAnalyticsPage from './pages/ReportingAnalyticsPage';
import CoachesPage from './pages/CoachesPage';
import UsersPage from './pages/UsersPage';
import FeedbackPage from './pages/FeedbackPage';
import CancellationFeedbackPage from './pages/CancellationFeedbackPage';
import AppUpdatesPage from './pages/AppUpdates';
import WellnessQAPage from './pages/WellnessQAPage';
import SupportDocsPage from './pages/SupportDocsPage';
// import SessionLoadModifiersPage from './pages/SessionLoadModifiersPage';
import TrainingTypesAndSportsPage from './pages/TrainingTypesAndSportsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import CampaignManagementPage from './pages/CampaignManagement';
import GlobalActivitiesPage from './pages/GlobalActivitiesPage';
import AlertRulesPage from './pages/AlertRulesPage';
import CRMPage from './pages/CRMPage';
import UserAnalyticsPage from './pages/UserAnalyticsPage';
import BackgroundGallery from './pages/BackgroundGallery';
import AdminsPage from './pages/AdminsPage';
import CommercialRequestsPage from './pages/commercial/CommercialRequestsPage';
import OrganisationsPage from './pages/commercial/OrganisationsPage';
import OrganisationDetailPage from './pages/commercial/OrganisationDetailPage';
import EmployeesPage from './pages/hr/EmployeesPage';
import ReportingPage from './pages/ReportingPage';
import SocialMonitoringPage from './pages/SocialMonitoringPage';
import ProfilePage from './pages/ProfilePage';
import DeletionRequestsPage from './pages/DeletionRequestsPage';
import PeakGlobalSettingsPage from './pages/PeakGlobalSettingsPage';
import PushNotificationsPage from './pages/PushNotificationsPage';

const AppRoutes = () => {   
  return (
    <Routes>
        <Route path="" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path='/dashboard' element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
        <Route path='/analytics' element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
        <Route path='/user-analytics' element={<PrivateRoute><UserAnalyticsPage /></PrivateRoute>} />
        <Route path='/users' element={<PrivateRoute><UsersPage /></PrivateRoute>} />
        <Route path='/coaches' element={<PrivateRoute><CoachesPage /></PrivateRoute>} />
        <Route path='/wizard' element={<PrivateRoute><LLMManagementPage /></PrivateRoute>} />
        <Route path='/reporting-analytics' element={<PrivateRoute><ReportingAnalyticsPage /></PrivateRoute>} />
        <Route path='/wellness-qa' element={<PrivateRoute><WellnessQAPage /></PrivateRoute>} />
        {/* <Route path='/session-lms' element={<PrivateRoute><SessionLoadModifiersPage /></PrivateRoute>} /> */}
        <Route path='/training-types-sports' element={<PrivateRoute><TrainingTypesAndSportsPage /></PrivateRoute>} />
        <Route path='/global-activities' element={<PrivateRoute><GlobalActivitiesPage /></PrivateRoute>} />
        <Route path='/alert-rules' element={<PrivateRoute><AlertRulesPage /></PrivateRoute>} />
        <Route path='/push-notifications' element={<PrivateRoute><PushNotificationsPage /></PrivateRoute>} />
        <Route path='/campaigns' element={<PrivateRoute><CampaignManagementPage /></PrivateRoute>} />
        <Route path='/updates' element={<PrivateRoute><AppUpdatesPage /></PrivateRoute>} />
        <Route path='/feedback' element={<PrivateRoute><FeedbackPage /></PrivateRoute>} />
        <Route path='/cancellation-feedback' element={<PrivateRoute><CancellationFeedbackPage /></PrivateRoute>} />
        <Route path='/reporting' element={<PrivateRoute><ReportingPage /></PrivateRoute>} />
        <Route path='/social-monitoring' element={<PrivateRoute><SocialMonitoringPage /></PrivateRoute>} />
        <Route path='/support-docs' element={<PrivateRoute><SupportDocsPage /></PrivateRoute>} />
        <Route path="/background-gallery" element={<PrivateRoute><BackgroundGallery /></PrivateRoute>} />
        <Route path='/peak-global-settings' element={<PrivateRoute><PeakGlobalSettingsPage /></PrivateRoute>} />
        <Route path='/crm' element={<PrivateRoute><CRMPage /></PrivateRoute>} />
        <Route path='/admins' element={<PrivateRoute><AdminsPage /></PrivateRoute>} />
        <Route path='/deletion-requests' element={<PrivateRoute><DeletionRequestsPage /></PrivateRoute>} />

        <Route path='/commercial/requests' element={<PrivateRoute><CommercialRequestsPage /></PrivateRoute>} />
        <Route path='/commercial/organisations' element={<PrivateRoute><OrganisationsPage /></PrivateRoute>} />
        <Route path='/commercial/organisations/:id' element={<PrivateRoute><OrganisationDetailPage /></PrivateRoute>} />

        <Route path='/hr/employees' element={<PrivateRoute><EmployeesPage /></PrivateRoute>} />

        <Route path='/profile' element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
        <Route path='/oauth/authorize' element={<PrivateRoute><OAuthPage /></PrivateRoute>} />
    </Routes>
  )
};

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <div className="w-full h-full min-h-screen">
                    <AppRoutes />
                </div>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
